<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import LaisCard from 'dashboard/components-next/LaisCard.vue';

const props = defineProps({
  installments: { type: Array, default: () => [] },
  downloadingId: { type: [Number, String], default: null },
  error: { type: String, default: '' },
});
const emit = defineEmits(['download']);
const { t } = useI18n();
const entries = computed(() =>
  props.installments.filter(
    installment => installment.mei_receipt?.visible !== false
  )
);
const formatDate = value => {
  if (!value) return t('SALES.DETAIL.EMPTY_VALUE');
  const date = new Date(value);
  return Number.isNaN(date.getTime())
    ? value
    : new Intl.DateTimeFormat('pt-BR', { timeZone: 'UTC' }).format(date);
};
</script>

<template>
  <LaisCard
    :title="t('SALES.DETAIL.COMMISSION.MEI.TITLE')"
    prefix-icon="i-lucide-file-text"
  >
    <p class="mb-4 text-sm text-lais-text-muted">
      {{ t('SALES.DETAIL.COMMISSION.MEI.SUBTITLE') }}
    </p>
    <p
      v-if="error"
      class="mb-4 rounded-lais-sm border border-red-200 bg-red-50 p-3 text-sm text-red-700"
    >
      {{ error }}
    </p>
    <p v-if="!entries.length" class="text-sm text-lais-text-muted">
      {{ t('SALES.DETAIL.COMMISSION.MEI.REVIEWING') }}
    </p>
    <div v-else class="grid gap-3">
      <article
        v-for="installment in entries"
        :key="installment.id"
        class="flex flex-wrap items-center justify-between gap-3 rounded-lais border border-lais-border-soft bg-lais-bg-soft p-4"
      >
        <div class="flex flex-wrap items-center gap-3 text-sm">
          <span
            v-if="installment.mei_receipt?.mode === 'installment'"
            class="rounded-full bg-lais-primary-50 px-2 py-1 text-xs font-bold text-lais-primary"
          >
            {{
              t('SALES.DETAIL.COMMISSION.MEI.INSTALLMENT', {
                number: installment.numero_parcela,
              })
            }}
          </span>
          <p
            v-if="installment.mei_receipt?.available"
            class="text-lais-text-muted"
          >
            {{ formatDate(installment.mei_receipt.date) }}
          </p>
          <p v-else class="text-lais-text-muted">
            {{ t('SALES.DETAIL.COMMISSION.MEI.REVIEWING') }}
          </p>
        </div>
        <button
          v-if="installment.mei_receipt?.available"
          type="button"
          class="font-semibold text-lais-primary underline-offset-2 hover:underline disabled:cursor-not-allowed disabled:opacity-50"
          :disabled="downloadingId === installment.id"
          @click="emit('download', installment)"
        >
          {{
            downloadingId === installment.id
              ? t('SALES.DETAIL.COMMISSION.MEI.DOWNLOADING')
              : installment.mei_receipt.link_label ||
                t('SALES.DETAIL.COMMISSION.MEI.DOWNLOAD')
          }}
        </button>
      </article>
    </div>
  </LaisCard>
</template>
